// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-smart-component {
  --height-smart-component-compact: 158px;
  --padding-component: 10px;
  --size-icon-main: 50px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  padding: var(--padding-component);
  background-color: white;
  min-height: var(--height-smart-component-compact);
}
.container-smart-component.supervision-view {
  --size-icon-main: 70px;
  --height-smart-component-compact: 70px;
  --padding-component: 0;
  height: -moz-fit-content;
  height: fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 200px;
  box-shadow: none;
  background-color: transparent;
}
.container-smart-component ion-button[disabled] {
  opacity: 1;
}
@media (max-width: 768px) {
  .container-smart-component:not(.supervision-view) {
    --height-smart-component-compact: 70px;
  }
  .container-smart-component:not(.supervision-view) ion-button {
    width: 50px;
    height: 50px;
  }
  .container-smart-component:not(.supervision-view) ion-button ion-icon {
    font-size: 36px;
  }
}

.container-spinner {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
  width: 100%;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.supervision-view .title {
  font-size: 15px;
}

.icon-and-text {
  display: flex;
  align-items: center;
  gap: 10px;
}
.icon-and-text.right-orientation {
  flex-direction: row-reverse;
  text-align: right;
}
.icon-and-text.up-orientation {
  gap: 5px;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
.icon-and-text.up-orientation .title {
  line-height: 2.1;
}
.icon-and-text.down-orientation {
  flex-direction: column-reverse;
  text-align: center;
  justify-content: center;
}
.icon-and-text {
  height: calc(var(--height-smart-component-compact) - var(--padding-component) * 2);
}

ion-button {
  --border-radius: 50%;
  --padding-start: 0;
  --padding-end: 0;
  width: 70px;
  height: 70px;
  --background: #E9E9E9;
  --box-shadow: 0;
  --ripple-color: #B60000;
  color: var(--ion-color-dark);
  --transition: transform .2s ease-out;
}
ion-button.turn-on {
  --background: #B60000;
}
ion-button.turn-on ion-icon {
  color: white;
}
ion-button ion-icon {
  font-size: 50px;
  color: var(--ion-color-medium);
  transition: transform 0.2s ease-out;
  position: absolute;
  top: 5px;
}
ion-button.ion-activated {
  scale: 1.1;
}

::ng-deep .vimar #alarmICon {
  position: static !important;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-alarm/widget-alarm.component.scss","webpack://./src/components/shared-components/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECDI,uCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,iCAAA;EACA,uBAAA;EACA,iDAAA;ADCJ;ACCI;EACI,sBAAA;EACA,sCAAA;EACA,sBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;ADCR;ACEI;EACI,UAAA;ADAR;AAlBI;EADA;IAEE,sCAAA;EAqBJ;EAnBI;IACE,WAAA;IACA,YAAA;EAqBN;EAnBM;IACE,eAAA;EAqBR;AACF;;AAfA;ECoCI,kFAAA;EACA,WAAA;ADjBJ;;AAhBA;EC2CI,eAAA;EACA,gBAAA;ADvBJ;;AAjBA;EACI,eAAA;AAoBJ;;AAjBA;ECJI,aAAA;EACA,mBAAA;EACA,SAAA;ADyBJ;ACvBI;EACI,2BAAA;EACA,iBAAA;ADyBR;ACtBI;EACI,QAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;ADwBR;ACtBQ;EACI,gBAAA;ADwBZ;ACpBI;EACI,8BAAA;EACA,kBAAA;EACA,uBAAA;ADsBR;AAzCA;EAEI,kFAAA;AA0CJ;;AAvCA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,4BAAA;EACA,oCAAA;AA0CJ;AAxCI;EACI,qBAAA;AA0CR;AAxCQ;EACI,YAAA;AA0CZ;AAtCI;EACI,eAAA;EACA,8BAAA;EACA,mCAAA;EACA,kBAAA;EACA,QAAA;AAwCR;AArCI;EACI,UAAA;AAuCR;;AAnCA;EACI,2BAAA;AAsCJ","sourcesContent":["@use \"../../styles/mixins\" as *;\n\n.container-smart-component {\n    @include external-apparance;\n\n    &:not(.supervision-view) {\n    @media (max-width: 768px) {\n      --height-smart-component-compact: 70px;\n      \n      ion-button {\n        width: 50px;\n        height: 50px;\n\n        ion-icon {\n          font-size: 36px;\n        }\n      }\n    }\n  }\n}\n\n.container-spinner {\n    @include container-spinenr;\n}\n\n.title {\n    @include title-main;\n}\n\n.supervision-view .title {\n    font-size: 15px;\n}\n\n.icon-and-text {\n    @include icon-and-text;\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n}\n\nion-button {\n    --border-radius: 50%;\n    --padding-start: 0;\n    --padding-end: 0;\n    width: 70px;\n    height: 70px;\n    --background: #E9E9E9;\n    --box-shadow: 0;\n    --ripple-color: #B60000;\n    color: var(--ion-color-dark);\n    --transition: transform .2s ease-out;\n\n    &.turn-on {\n        --background: #B60000;\n\n        ion-icon {\n            color: white;\n        }\n    }\n\n    ion-icon {\n        font-size: 50px;\n        color: var(--ion-color-medium);\n        transition: transform .2s ease-out;\n        position: absolute;\n        top: 5px;\n    }\n\n    &.ion-activated {\n        scale: 1.1;\n    }\n}\n\n::ng-deep .vimar #alarmICon {\n    position: static !important;\n}","@mixin external-apparance {\n    --height-smart-component-compact: 158px;\n    --padding-component: 10px;\n    --size-icon-main: 50px;\n    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    border-radius: 15px;\n    display: flex;\n    flex-direction: column;\n    padding: var(--padding-component);\n    background-color: white;\n    min-height: var(--height-smart-component-compact);\n\n    &.supervision-view {\n        --size-icon-main: 70px;\n        --height-smart-component-compact: 70px;\n        --padding-component: 0;\n        height: fit-content;\n        width: fit-content;\n        max-width: 200px;\n        box-shadow: none;\n        background-color: transparent;\n    }\n\n    ion-button[disabled] {\n        opacity: 1;\n    }\n}\n\n@mixin icon-and-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    &.right-orientation {\n        flex-direction: row-reverse;\n        text-align: right;\n    }\n\n    &.up-orientation {\n        gap: 5px;\n        flex-direction: column;\n        text-align: center;\n        justify-content: center;\n\n        .title {\n            line-height: 2.1;\n        }\n    }\n\n    &.down-orientation {\n        flex-direction: column-reverse;\n        text-align: center;\n        justify-content: center;\n    }\n}\n\n@mixin container-spinenr {\n    height: calc(var(--height-smart-component-compact) - (var(--padding-component) * 2));\n    width: 100%;\n}\n\n@mixin icon-main {\n    width: var(--size-icon-main);\n    height: var(--size-icon-main);\n    flex-shrink: 0;\n}\n\n@mixin title-main {\n    font-size: 18px;\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
